/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataResponse_CalorieDeviationResponse_ } from "../models/DataResponse_CalorieDeviationResponse_";
import type { DataResponse_ProteinBalanceResponse_ } from "../models/DataResponse_ProteinBalanceResponse_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class BalanceService {
  /**
   * Get Calorie Deviation
   * Get calorie deviation between plan and target calories for the week.
   *
   * Returns the difference between the event-resolved plan calories
   * and the plan's weekly calorie target.
   * @param xUserId
   * @returns DataResponse_CalorieDeviationResponse_ Successful Response
   * @throws ApiError
   */
  public static getCalorieDeviationApiV1BalanceCaloriesGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_CalorieDeviationResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/balance/calories",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Protein Balance
   * Get the weekly protein balance.
   *
   * Returns the average consumed protein (g) across the week's completed days
   * alongside the user's daily protein target (minimumProtein, g).
   * @param xUserId
   * @returns DataResponse_ProteinBalanceResponse_ Successful Response
   * @throws ApiError
   */
  public static getProteinBalanceApiV1BalanceProteinGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_ProteinBalanceResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/balance/protein",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
